import Vue from 'vue'

export default {
    resetStateMutation(state) {
        Vue.set(state, "operationsIsShow", true);
        Vue.set(state, "eKatFormIsShow", false);
    },

    showOperationEkatForm(state) {
        state.operationsIsShow = false;
        state.eKatFormIsShow = true;
    },
    showPatientOperationsTable(state) {
        state.operationsIsShow = true;
        state.eKatFormIsShow = false;
    }
}
